import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutCarrierQualProfileValueSelectorPopup extends Layout {
}
